import * as types from '../types'
import update from 'immutability-helper'
import moment from 'moment';

export const initialStatusForm = {
    id: 0,
    companyID: 0,
    applicantName: '',
    applicantCode: '',
    dateOfApplication: moment().format('MM/DD/YYYY'),
    jobTitle: '',
    statusDetail: [],
}

const defaultState = {
    loading: false,
    error: false,
    statusForm: { ...initialStatusForm },
}

export default function statusReducer(state = defaultState, action) {
    switch (action.type) {
        // LOGIN STATUS FIELDS
        case types.CHG_STATUS_DATA:
            return update(state, {
                statusForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            })
        case types.IS_LOADING:
            return update(state, {
                loading: { $set: action.payload }
            })
        case types.CHG_COMP_ID:
            return update(state, {
                CompanyID: { $set: action.payload }
            })
        case types.SET_APPLICANT_STATUS_DATA:
            return update(state, {
                statusForm: { $set: action.payload.data }
            })
        case types.ERR_404:
            return update(state, {
                error: { $set: action.payload }
            })
        default: return state;
    }
}